var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var ArrowRight = function ArrowRight(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "M5 11a1 1 0 1 0 0 2h11.865l-3.633 4.36a1 1 0 1 0 1.536 1.28l4.989-5.986a.995.995 0 0 0 .146-1.084.993.993 0 0 0-.146-.224L14.768 5.36a1 1 0 1 0-1.536 1.28L16.865 11H5Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default ArrowRight;